import { FC } from 'react';
// Interfaces
import { IconSvgProps } from '@utmb/types/icons';

const Events: FC<IconSvgProps> = ({ color, clss, width, height }) => {
    return (
        <svg className={clss} width={width} height={height} viewBox="0 0 43.45 43.43">
            <polygon fill={color} points="37.91 3.36 35.93 5.22 41.58 5.22 41.58 12.64 1.86 12.64 1.86 5.22 6.72 5.22 8.7 3.36 0 3.36 0 40.84 1.86 39.08 1.86 14.51 41.58 14.51 41.58 41.56 1.95 41.56 0 43.41 0 43.43 43.45 43.43 43.45 3.36 37.91 3.36"/>
            <polygon fill={color} points="29.85 3.36 16.75 3.36 14.77 5.22 27.88 5.22 29.85 3.36"/>
            <path fill={color} d="M24.6,24.39l-2.87-5.82-2.87,5.82-6.43.93,4.65,4.53-1.1,6.4,5.75-3.02,5.75,3.02-1.1-6.4,4.65-4.53-6.43-.93ZM24.99,32.85l-3.27-1.72-3.27,1.72.62-3.64-2.65-2.58,3.66-.53,1.64-3.31,1.64,3.31,3.66.53-2.65,2.58.63,3.64Z"/>
            <rect fill={color} x="31.84" width="1.86" height="6.05"/>
            <rect fill={color} x="10.48" y=".02" width="1.86" height="6.05"/>
        </svg>
    );
};

export default Events;
